module.exports = __webpack_public_path__ + "static/media/noise.b78985cf.png";